import { makeAutoObservable } from 'mobx'
import { apiClient } from '../service/ApiClient'
import { Location } from '../types/models/Locations'
import { User } from '../types/models/User'

export class SettingsStore {
  locationId: string | undefined | null
  location: Location | undefined | { name: string }
  kiosk: string | undefined | null

  user: User | undefined | null
  timer: any
  clientId: string | undefined
  ip: string | undefined

  constructor() {
    this.kiosk = localStorage.getItem('kiosk')
    this.locationId = localStorage.getItem('locationId')
    const locationName = localStorage.getItem('location')
    this.location = locationName ? { name: locationName } : undefined
    this.initKiosk()
    makeAutoObservable(this)
  }

  initKiosk() {
    const kiosk = new URLSearchParams(window.location.search).get('kiosk')
    const value = kiosk === 'full' ? 'full' : kiosk === '' ? 'true' : kiosk
    if (value) {
      this.kiosk = value
      localStorage.setItem('kiosk', value)
    }
  }

  setUser(user?: User) {
    clearTimeout(this.timer)
    this.user = user
    apiClient.defaults.headers.common['user'] = `${user ? user.id : ''}`
    this.timer = setTimeout(() => {
      this.clearUser()
    }, 60000)
  }

  clearUser() {
    this.user = undefined
    clearTimeout(this.timer)
    apiClient.defaults.headers.common['user'] = `${''}`
  }
}
